import { FC } from "react";
import CategoryStatusTable from "../CategoryStatusTable";
import useProjectManagementStatus, { Props, ReceivedProps } from "./hook";
import { Styles } from "./styled";

const ProjectManagementStatusLayout: FC<Props> = () => {
  return (
    <Styles>
      <CategoryStatusTable screen="project_manage" recordType="status" />
    </Styles>
  );
};

const ProjectManagementStatus: FC<ReceivedProps> = (props) => (
  <ProjectManagementStatusLayout {...useProjectManagementStatus(props)} />
);

export default ProjectManagementStatus;
